var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-field',{attrs:{"validation":_vm.$v.payment_method,"validationMessage":_vm.textRequired,"list":_vm.paymentMethods,"rest":{
    placeholder: _vm.textTitle
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},model:{value:(_vm.form.payment_method),callback:function ($$v) {_vm.$set(_vm.form, "payment_method", $$v)},expression:"form.payment_method"}})}
var staticRenderFns = []

export { render, staticRenderFns }